import React from "react";

export default {
  join: (
    <p>
      Add this submission to a group.
      <br />
      Ask the group owner for the name and passcode.
    </p>
  ),
  create: (
    <p>
      Set the name and passcode, your friends will use these to add their
      predictions to your group. Each group will have its own leaderboard.
      <br />
      This submission will be automatically added to your newly created group.
      <br />A group can be reused across multiple competitions.
    </p>
  ),
  manage: (
    <p>
      Edit the info or delete your created groups.
      <br />
      For security the group passcode must be reset on every edit.
      <br />
      For individual member management go to the leaderboard for the group.
    </p>
  ),
};
